import { connect } from 'react-redux';

import createKeyedSelectorCreator from 'utils/createKeyedSelectorCreator';

import stylingSelectors from '../selectors';
import { getMergedStyling } from '../selectors/mergedStylingSelectors';
import {
  DEFAULT_SURVEY_STYLES_STATE_PATH,
  LOCAL_STYLING_STATE_PATH,
  STYLING_STATE_PATH,
} from '../reducers';

const { getDefaultSurveyStyles, getLocalStyling } = stylingSelectors;

const createBlockSelector = createKeyedSelectorCreator('clientUuid');

const getStylingState = createBlockSelector(
  (state, { block }) => block,
  getDefaultSurveyStyles,
  getLocalStyling,
  (block, stylingDefault, stylingLocal) => ({
    block,
    [STYLING_STATE_PATH]: {
      [DEFAULT_SURVEY_STYLES_STATE_PATH]: stylingDefault,
      [LOCAL_STYLING_STATE_PATH]: stylingLocal,
    },
  }),
);

const createSTPSelector = createKeyedSelectorCreator('block.clientUuid');

const mapStateToProps = createSTPSelector(
  getStylingState,
  ({ block, ...state }) => {
    const { mergedStyling, localStyling } = getMergedStyling(state, block);
    return { styling: { ...mergedStyling, meta: { localStyling } } }; // setting localStyling as metaData as initial styling value @sinslav
  },
);

export default connect(mapStateToProps);
